/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Op is the operation to apply.
 *
 *  - EQUALS: Operators on scalar values. Only applies to one of |int_value|,
 * |long_value|, |string_value| or |timestamp_value|.
 *  - IN: Checks if the value is a member of a given array, which should be one of
 * |int_values|, |long_values| or |string_values|.
 *  - IS_SUBSTRING: Checks if the value contains |string_value| as a substring match. Only
 * applies to |string_value|.
 * @export
 */
export const PredicateOp = {
  UNKNOWN: 'UNKNOWN',
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_EQUALS: 'GREATER_THAN_EQUALS',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_EQUALS: 'LESS_THAN_EQUALS',
  IN: 'IN',
  IS_SUBSTRING: 'IS_SUBSTRING',
} as const;
export type PredicateOp = (typeof PredicateOp)[keyof typeof PredicateOp];

export function instanceOfPredicateOp(value: any): boolean {
  for (const key in PredicateOp) {
    if (Object.prototype.hasOwnProperty.call(PredicateOp, key)) {
      if (PredicateOp[key as keyof typeof PredicateOp] === value) {
        return true;
      }
    }
  }
  return false;
}

export function PredicateOpFromJSON(json: any): PredicateOp {
  return PredicateOpFromJSONTyped(json, false);
}

export function PredicateOpFromJSONTyped(json: any, ignoreDiscriminator: boolean): PredicateOp {
  return json as PredicateOp;
}

export function PredicateOpToJSON(value?: PredicateOp | null): any {
  return value as any;
}

export function PredicateOpToJSONTyped(value: any, ignoreDiscriminator: boolean): PredicateOp {
  return value as PredicateOp;
}
